"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filterEcommEvents = function (obj) {
    var newObj = {};
    var invalidKeys = ['hitType', 'customTrackerId', 'ecommType', 'actionName'];
    Object.keys(obj).forEach(function (key) {
        if (invalidKeys.indexOf(key) === -1) {
            newObj[key] = obj[key];
        }
    });
    return newObj;
};
exports.default = filterEcommEvents;
